module.exports = __webpack_public_path__ + "img/6.16b55ffd.png";